import { render, staticRenderFns } from "./JoeyBrandName.vue?vue&type=template&id=093bd96c"
import script from "./JoeyBrandName.vue?vue&type=script&lang=ts"
export * from "./JoeyBrandName.vue?vue&type=script&lang=ts"
import style0 from "./JoeyBrandName.vue?vue&type=style&index=0&id=093bd96c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports